import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import {showOverlay} from '../../../v2/actions/overlay-actions';
import BasketItemImageWrapper from '../../../v2/components/BasketItemImage/BasketItemImageWrapper';
import BagIcon from '../../../v2/components/ui/svg/Components/BagIcon';
import Translation from '../../../v2/lang/Translation';
import {getDeliveryGroups} from '../../../v2/selectors/DeliveryOptionsSelectors/DeliveryOptionsSelectors';
import BasketItemsProptype from '../../../propTypes/BasketItems.proptype';
import Spacing from '../../../v2/style-helper/Spacing';

const useStyles = createUseStyles({
  deliveryOptionProductImageWrapper: {
    border: props => props.mergedGroupsEnabled && !props.unshippableReason && '1px solid #F2F2F2',
    marginBottom: props => props.mergedGroupsEnabled && !props.unshippableReason && Spacing.triple,
    
    '&:last-child': {
      marginBottom: props => props.mergedGroupsEnabled && 0,
    },
  },
  deliveryOptionProductImageContainer: {
    cursor: 'pointer',
    border: '2px solid transparent',
    
    '&:focus, :hover': {
      borderColor: props => props.theme.core.brand,
      boxShadow: props => `0 0 0 1 ${props.theme.core.brand}`,
    },
  },
  title: {
    display: 'flex',
    alignItems: 'end',
    fontSize: props => props.theme.base.fontSize,
    margin: 11,
  },
  iconWrapper: {
    marginRight: Spacing.single,
  },
});

export function DeliveryOptionProductImageContainer(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const handleOpenProductPreview = () => {
    if (props.mergedGroupsEnabled) {
      props.openProductPreview(props.deliveryNumber, props.numberOfDeliveries);
    } else {
      props.openProductPreview(props.groupId + 1, props.deliveryGroupsSize);
    }
  };
  
  return (
    <div className={classes.deliveryOptionProductImageWrapper}>
      <Button
        className={classes.deliveryOptionProductImageContainer}
        id={`DeliveryOptionProductImageContainer__button--${props.groupId}`}
        data-test="DeliveryOptionProductImageContainer__button"
        ariaLabel={props.deliveryGroupsSize > 1
          ? Translation.getText('deliveryOptions.yourItemsGroup', props.groupId + 1)
          : Translation.getText('deliveryOptions.yourItems')}
        onClick={handleOpenProductPreview}
        link
        noStyle
        fullWidth
        leftAlign
      >
        {props.mergedGroupsEnabled && !props.unshippableReason && (
          <div className={classes.title}>
            <div className={classes.iconWrapper}>
              <BagIcon />
            </div>
            <h6 className={classes.iconWrapper}>
              <Translation placeholderValues={[props.deliveryNumber, props.numberOfDeliveries]}>
                deliveryOptions.yourItems
              </Translation>
            </h6>
            <h6>
              <Translation placeholderValues={[props.minDays, props.maxDays]}>
                delivery.options.date.range
              </Translation>
            </h6>
          </div>
        )}
        <BasketItemImageWrapper
          basketItems={props.filteredBasketItems}
          mergedGroupsEnabled={props.mergedGroupsEnabled}
          isDeliverySection
          isDiggecardDeliveryOption={props.isDiggecardDeliveryOption}
        />
      </Button>
    </div>
  );
}

DeliveryOptionProductImageContainer.propTypes = {
  filteredBasketItems: PropTypes.arrayOf(PropTypes.shape(BasketItemsProptype)).isRequired,
  groupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  openProductPreview: PropTypes.func.isRequired,
  isFastDeliveryContainer: PropTypes.bool,
  shouldFilterOutFastDeliveryItems: PropTypes.bool,
  mergedGroupsEnabled: PropTypes.bool,
  deliveryGroupsSize: PropTypes.number,
  deliveryNumber: PropTypes.number,
  numberOfDeliveries: PropTypes.number,
  minDays: PropTypes.number,
  maxDays: PropTypes.number,
  isDiggecardDeliveryOption: PropTypes.bool,
};

DeliveryOptionProductImageContainer.defaultProps = {
  isFastDeliveryContainer: false,
  shouldFilterOutFastDeliveryItems: false,
};

const mapStateToProps = (state, ownProps) => ({
  deliveryGroupsSize: getDeliveryGroups(state).length,
  filteredBasketItems: ownProps.shouldFilterOutFastDeliveryItems
    ? ownProps.basketItems.filter(item => !item.fastDelivery)
    : ownProps.basketItems,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  openProductPreview: (groupId, deliveryGroupsSize) => dispatch(showOverlay('delivery_option_product_preview', {
    isFastTrackGroup: ownProps.isFastTrackGroup,
    unshippableReason: ownProps.unshippableReason,
    basketItems: ownProps.basketItems,
    groupId,
    deliveryGroupsSize,
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryOptionProductImageContainer);
